// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.10.0_webpack@5.94.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.10.0_webpack@5.94.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  overflow: hidden;
}

html,
body {
  height: 100%;
  width: 100%;
  overflow: auto
}

@media (max-width: 707px) {

html,
body {
    overflow-x: hidden
}
  }

#logo {
  height: 40%
}

@media (max-width: 707px) {

#logo {
    margin-right: 90px;
    height: 55%
}
  }

#onboarding-layout__container {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

#onboarding-layout__header {
  background: linear-gradient(to right, #198c9d, #6d239c);
  width: 100%;
  height: 105px;
  padding-left: 90px;
  display: flex;
  align-items: center;
  justify-content: space-between
}

@media (max-width: 707px) {

#onboarding-layout__header {
    justify-content: center;
    height: 120px
}
  }

#chicory-banner-squares {
  width: 335px;
  height: 100%;
}

#onboarding-layout__body {
  padding-top: 40px;
  padding-left: 100px;
  padding-right: 100px;
  flex-grow: 1
}

@media (max-width: 707px) {

#onboarding-layout__body {
    padding-left: 30px;
    padding-right: 30px
}
  }

#onboarding-layout__footer {
  min-height: 2.5rem;
  display: flex;
  align-items: center;
  padding-left: 100px;
  background: #f5f5f5;
  font-size: 0.7rem
}

@media (max-width: 707px) {

#onboarding-layout__footer {
    padding-left: 0px;
    justify-content: center
}
  }

@media (max-width: 707px) {
  #chicory-banner-squares {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Onboarding/OnboardingLayout.pcss"],"names":[],"mappings":"AAGA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;EACZ,WAAW;EACX;AAIF;;AAHE;;AALF;;IAMI;AAEJ;EADE;;AAGF;EACE;AAKF;;AAJE;;AAFF;IAGI,kBAAkB;IAClB;AAEJ;EADE;;AAGF;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,uDAAuD;EACvD,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB;AAKF;;AAJE;;AARF;IASI,uBAAuB;IACvB;AAEJ;EADE;;AAGF;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,mBAA0B;EAC1B,oBAA2B;EAC3B;AAKF;;AAJE;;AALF;IAMI,kBAAkB;IAClB;AAEJ;EADE;;AAGF;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAA0B;EAC1B,mBAAmB;EACnB;AAKF;;AAJE;;AAPF;IAQI,iBAAiB;IACjB;AAEJ;EADE;;AAGF;EACE;IACE,aAAa;EACf;AACF","sourcesContent":["$bodyPadding: 100px;\n$mobile: 707px;\n\nhtml {\n  overflow: hidden;\n}\n\nhtml,\nbody {\n  height: 100%;\n  width: 100%;\n  overflow: auto;\n  @media (max-width: $mobile) {\n    overflow-x: hidden;\n  }\n}\n\n#logo {\n  height: 40%;\n  @media (max-width: $mobile) {\n    margin-right: 90px;\n    height: 55%;\n  }\n}\n\n#onboarding-layout__container {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n}\n\n#onboarding-layout__header {\n  background: linear-gradient(to right, #198c9d, #6d239c);\n  width: 100%;\n  height: 105px;\n  padding-left: 90px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  @media (max-width: $mobile) {\n    justify-content: center;\n    height: 120px;\n  }\n}\n\n#chicory-banner-squares {\n  width: 335px;\n  height: 100%;\n}\n\n#onboarding-layout__body {\n  padding-top: 40px;\n  padding-left: $bodyPadding;\n  padding-right: $bodyPadding;\n  flex-grow: 1;\n  @media (max-width: $mobile) {\n    padding-left: 30px;\n    padding-right: 30px;\n  }\n}\n\n#onboarding-layout__footer {\n  min-height: 2.5rem;\n  display: flex;\n  align-items: center;\n  padding-left: $bodyPadding;\n  background: #f5f5f5;\n  font-size: 0.7rem;\n  @media (max-width: $mobile) {\n    padding-left: 0px;\n    justify-content: center;\n  }\n}\n\n@media (max-width: $mobile) {\n  #chicory-banner-squares {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
